import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Font } from '@shared/commons/Graphics';
import { MenuIcons } from '@shared/utils/Enums/MenuIcons';
import { StringUtils } from '@shared/utils/StringUtils';
import AboutIcon from '@styles/webdesktop/Icons/aboutIcon.svg';
import AccountLookup from '@styles/webdesktop/Icons/accountLookup.svg';
import AccountStatistics from '@styles/webdesktop/Icons/accountStatistics.svg';
import AssetIcon from '@styles/webdesktop/Icons/assetIcon.svg';
import BrokerInfo from '@styles/webdesktop/Icons/brokerInfoIcon.svg';
import ChangePasswordIcon from '@styles/webdesktop/Icons/changePassowordIcon.svg';
import ChartIcon from '@styles/webdesktop/Icons/chartIcon.svg';
import ReportsIcon from '@styles/webdesktop/Icons/reportsIcon.svg';
import ChartTV from '@styles/webdesktop/Icons/chartTV.svg'; // TradingView
import TimeAndSalesIcon from '@styles/webdesktop/Icons/timeAndSalesIcon.svg';
import WatchListIcon from '@styles/webdesktop/Icons/watchListIcon.svg';
import GridIcon from '@styles/webdesktop/Icons/gridIcon.svg';
import TradingTools from '@styles/webdesktop/Icons/tradingTools.svg';
import OrderEntry from '@styles/webdesktop/Icons/orderEntry.svg';
import OptionMaster from '@styles/webdesktop/Icons/optionMaster.svg';
import SavedOrder from '@styles/webdesktop/Icons/savedOrder.svg';
import MarketDepth from '@styles/webdesktop/Icons/marketDepth.svg';
import PositionsIcon from '@styles/webdesktop/Icons/positionsIcon.svg';
import WithdrawalIcon from '@styles/webdesktop/Icons/withdrawalIcon.svg';
import WorkingOrder from '@styles/webdesktop/Icons/workingOrder.svg';
import OrderHistory from '@styles/webdesktop/Icons/orderHistory.svg';
import FilledOrder from '@styles/webdesktop/Icons/filledOrder.svg';
import PositionBalance from '@styles/webdesktop/Icons/positionBalance.svg';
import NewsIcon from '@styles/webdesktop/Icons/newsIcon.svg';
import StatementIcon from '@styles/webdesktop/Icons/statementIcon.svg';
import HeatMapIcon from '@styles/webdesktop/Icons/heatmapIcon.svg';
import HighLowList from '@styles/webdesktop/Icons/highLowList.svg';
import GainersLosers from '@styles/webdesktop/Icons/gainersLosers.svg';
import OnboardingIcon from '@styles/webdesktop/Icons/onboardingIcon.svg';
import DownloadLogFile from '@styles/webdesktop/Icons/downloadLogFile.svg';
import HomePage from '@styles/webdesktop/Icons/homePage.svg';
import TradingCentral from '@styles/webdesktop/Icons/tradingCentral.svg';
import LiveAccount from '@styles/webdesktop/Icons/liveAccount.svg';
import SubscriptionsIcon from '@styles/webdesktop/Icons/subscriptionsIcon.svg';
import CopyTrading from '@styles/webdesktop/Icons/copyTrading.svg';
import ChangeTradingPassword from '@styles/webdesktop/Icons/changeTradingPassword.svg';
import CloseAccount from '@styles/webdesktop/Icons/closeAccount.svg';
import Webhooks from '@styles/webdesktop/Icons/webhooks.svg';
import { ControlsUtils } from '../../UtilsClasses/ControlsUtils';
const TEXT_ICON_SIZE = 8;
const TEXT_ICON_FONT = new Font(TEXT_ICON_SIZE, 'Trebuchet MS, Arial, sans-serif', 'bold');
class _IconsFactory {
    getIcon(iconType) {
        switch (iconType) {
            case MenuIcons.ChartIcon:
                return _jsx(ChartIcon, {});
            case MenuIcons.ChartTV:
                return _jsx(ChartTV, {});
            case MenuIcons.WatchListIcon:
                return _jsx(WatchListIcon, {});
            case MenuIcons.TimeAndSalesIcon:
                return _jsx(TimeAndSalesIcon, {});
            case MenuIcons.GridIcon:
                return _jsx(GridIcon, {});
            case MenuIcons.TradingTools:
                return _jsx(TradingTools, {});
            case MenuIcons.OrderEntry:
                return _jsx(OrderEntry, {});
            case MenuIcons.OptionMaster:
                return _jsx(OptionMaster, {});
            case MenuIcons.SavedOrder:
                return _jsx(SavedOrder, {});
            case MenuIcons.MarketDepth:
                return _jsx(MarketDepth, {});
            case MenuIcons.PositionsIcon:
                return _jsx(PositionsIcon, {});
            case MenuIcons.WorkingOrder:
                return _jsx(WorkingOrder, {});
            case MenuIcons.OrderHistory:
                return _jsx(OrderHistory, {});
            case MenuIcons.FilledOrder:
                return _jsx(FilledOrder, {});
            case MenuIcons.AssetIcon:
                return _jsx(AssetIcon, {});
            case MenuIcons.PositionBalance:
                return _jsx(PositionBalance, {});
            case MenuIcons.News:
                return _jsx(NewsIcon, {});
            case MenuIcons.StatementIcon:
                return _jsx(StatementIcon, {});
            case MenuIcons.HeatMapIcon:
                return _jsx(HeatMapIcon, {});
            case MenuIcons.HighLowList:
                return _jsx(HighLowList, {});
            case MenuIcons.GainersLosers:
                return _jsx(GainersLosers, {});
            case MenuIcons.AboutIcon:
                return _jsx(AboutIcon, {});
            case MenuIcons.BrokerInfo:
                return _jsx(BrokerInfo, {});
            case MenuIcons.OnboardingIcon:
                return _jsx(OnboardingIcon, {});
            case MenuIcons.DownloadLogFile:
                return _jsx(DownloadLogFile, {});
            case MenuIcons.HomePage:
                return _jsx(HomePage, {});
            case MenuIcons.TradingCentral:
                return _jsx(TradingCentral, {});
            case MenuIcons.CopyTrading:
                return _jsx(CopyTrading, {});
            case MenuIcons.LiveAccount:
                return _jsx(LiveAccount, {});
            case MenuIcons.ReportsIcon:
                return _jsx(ReportsIcon, {});
            case MenuIcons.ChangePasswordIcon:
                return _jsx(ChangePasswordIcon, {});
            case MenuIcons.WithdrawalIcon:
                return _jsx(WithdrawalIcon, {});
            case MenuIcons.SubscriptionsIcon:
                return _jsx(SubscriptionsIcon, {});
            case MenuIcons.AccountStatistics:
                return _jsx(AccountStatistics, {});
            case MenuIcons.ChangeTradingPassword:
                return _jsx(ChangeTradingPassword, {});
            case MenuIcons.CloseAccount:
                return _jsx(CloseAccount, {});
            case MenuIcons.AccountLookup:
                return _jsx(AccountLookup, {});
            case MenuIcons.Webhooks:
                return _jsx(Webhooks, {});
            default:
                return null;
        }
    }
    getIconByType(iconType, text) {
        var _a;
        return (_a = this.getIcon(iconType)) !== null && _a !== void 0 ? _a : this.generateSvgIcon(text);
    }
    generateSvgIcon(text) {
        const shortName = StringUtils.getAbbreviateText(text);
        const fontFamily = 'Trebuchet MS, Arial, sans-serif';
        const fontSize = TEXT_ICON_SIZE;
        const textWidth = ControlsUtils.GetTextWidth(shortName, TEXT_ICON_FONT);
        const x = (16 - textWidth) / 2;
        const letterSpacing = x < 2 ? -Math.abs(x) : 0;
        return (_jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("rect", { x: "1.5", y: "0.5", width: "13", height: "15", rx: "1", stroke: "currentColor", fill: "none" }), _jsx("text", { x: x, y: "11", letterSpacing: letterSpacing, fontSize: fontSize, fontFamily: fontFamily, fontWeight: "bold", fill: "currentColor", children: shortName })] }));
    }
}
export const IconsFactory = new _IconsFactory();
